import React, { useState } from 'react';

import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import classnames from 'classnames';
import { OTLink } from '../../../components/tag/OTLink';
import { UserInfoRequestList } from '../../userInfoRequest/components/userInfoRequestList';
import {
  checkViksuHealth,
  serviceStatus,
} from '../../../data/user/userInfoRequests/actions';
import { USER } from '../../../data/reducer';
import { FormattedMessage } from 'react-intl';
import { ViksuConnectionError } from '../../userInfoRequest/ViksuConnectionError';
import {
  FEATURE_USERINFOREQUEST_DISABLED,
  isFeatureOn,
} from '../../../definitions/Config';

const UserInfoRequests = ({
  userInfoRequestState,
  hasActiveSuomiFiInbox,
  checkViksuHealth,
}) => {
  const { userInfoRequests: requests } = userInfoRequestState;
  const [showForm, setShowForm] = useState(false);
  const collapsibleClassNames = classnames('ot-form', 'ot-collapsible-form', {
    'ot-collapsible-form--icon-open': 'true',
  });

  const toggleShowForm = () => {
    checkViksuHealth();
    setShowForm((prev) => {
      return !prev;
    });
  };

  return (
    <div className="row-fluid">
      <div className="span12">
        <Collapsible
          className={collapsibleClassNames}
          openedClassName={collapsibleClassNames}
          handleTriggerClick={toggleShowForm}
          open={showForm}
          trigger={
            <span>
              <i className="icon-file" />{' '}
              <h2 style={{ marginLeft: '5px' }}>
                <FormattedMessage id={`${module.id}.userInfoRequests`} />
              </h2>
            </span>
          }
        >
          <div className="userinfo-requests" id="userinfo-request">
            <div className="userinfo-requests__row">
              {isFeatureOn(FEATURE_USERINFOREQUEST_DISABLED) && (
                <UserInfoDescription />
              )}
              {!hasActiveSuomiFiInbox && <SuomiFiMessages />}
              {userInfoRequestState.viksuStatus === serviceStatus.FAILED ? (
                <ViksuConnectionError />
              ) : (
                <div>
                  {!isFeatureOn(FEATURE_USERINFOREQUEST_DISABLED) && (
                    <SendUserInfoRequest
                      viksuStatus={userInfoRequestState.viksuStatus}
                      hasActiveSuomiFiInbox={hasActiveSuomiFiInbox}
                    />
                  )}
                  {requests && <UserInfoRequestList requests={requests} />}
                </div>
              )}
            </div>
          </div>
        </Collapsible>
      </div>
    </div>
  );
};

const UserInfoDescription = () => {
  return (
    <div className="userinfo-requests__description">
      <p>
        <FormattedMessage
          id={`${module.id}.userInfoRequestsDescription`}
          values={{
            a: (chunks) => (
              <a
                href="https://www.pirha.fi/sahkoinen-asiointi"
                target="_blank"
                rel="noreferrer"
              >
                {chunks}
              </a>
            ),
          }}
        />
      </p>
    </div>
  );
};

const SuomiFiMessages = () => {
  return (
    <p>
      <br />
      <FormattedMessage
        id={`${module.id}.info.sfi.inactive`}
        values={{
          a: (chunks) => (
            <a href="https://www.suomi.fi/viestit" target="_blank">
              {chunks}
            </a>
          ),
          icon: (chunks) => (
            <i className="icon-external-link fa ot-icon ot-icon--blue">
              {chunks}
            </i>
          ),
        }}
      />
    </p>
  );
};
const SendUserInfoRequest = () => {
  return (
    <div className="userinfo-requests__action">
      <OTLink link={'/userinforequest'} className="ot-button">
        <FormattedMessage id={`${module.id}.sendRequest`} />
      </OTLink>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userInfoRequestState: state[USER].userInfoRequests,
    hasActiveSuomiFiInbox: state[USER].officialServices.isInboxActive,
  };
};

export default connect(mapStateToProps, {
  checkViksuHealth,
})(UserInfoRequests);
